// Please also add the variables defined here to /docker/entrypoint.sh.

export const APP_LOGO_URL: string = '';
export const APP_BACKEND_API_ENDPOINT: string = 'http://php_backend:8080';
export const APP_LOCALE: string = 'de_DE';
export const OPENCAL_VERSION: string = 'smsfreundlich-20261102';
export const APP_PUBLIC_BOOKING_EMAIL: string = 'christian@froehlich-versichert.com';
export const APP_IMPRINT_URL: string = 'https://www.froehlich-versichert.com/impressum/';
export const APP_PRIVACY_URL: string = 'https://www.froehlich-versichert.com/datenschutz/';
// Zeitzone, in der das Backend die Zeitfenster berechnet und ausliefert.
// Die Slots kommen als reine H:i-Strings ohne Zeitzonenangabe (AvailabilityService),
// deshalb muss die Oberflaeche selbst dazusagen, worauf sie sich beziehen.
export const APP_TIMEZONE: string = 'Europe/Berlin';
